export enum LangEnum {
  EN = 'en',
  ZH_CN = 'zh-CN',
  ZH_HK = 'zh-HK',
}
